import * as ACTION_TYPES from '../types';



let initialState = {
  equipmentTreesList: [],
  equipmentTree: {}
 }


export default (state = { equipmentTreesList: [] }, action) => {
  switch (action.type) {

    case ACTION_TYPES.GET_EQUIPMENTTREES:
      return { ...state, equipmentTreesList: action.data };

    case ACTION_TYPES.REQUEST:
      return { ...state, loading: true };

    case ACTION_TYPES.DONE:
      return { ...state, loading: false };

    case ACTION_TYPES.RESET_EQUIPMENTTREES:
      return { ...state, equipmentTreesList: [] };

    case ACTION_TYPES.GET_EQUIPMENTTREE_BY_ID:
      return { ...state, equipmentTree: action.data }

    default:
      return state;
  }
};